import { useCallback, useState } from 'react';
import axios from '../../../../api/axios';
import useAuth from '../../../../utils/hooks/useAuth';

/**
 * Custom hook for fetching company data from a URL using AI
 * Handles extracting company information from website URLs
 */
export const useGetUserSessions = () => {
  const {
    authData: { userData },
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Fetch company data from a URL
   * @param url - The website URL to extract data from
   * @returns Promise that resolves with the extracted company data
   */
  const getSessions = useCallback(async (): Promise<any> => {
    if (!userData?.id) return null;

    setIsLoading(true);

    try {
      const response = await axios.get('/ai/sessions', {
        headers: {
          'Content-Type': 'application/json',
          'X-User-ID': String(userData.id),
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching data from URL:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [userData?.id]);

  return { getSessions, isLoading };
};
